export const generateToken = async () => {
    try {
        const url = "https://trackapi.thailandpost.co.th/post/api/v1/authenticate/token";
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${process.env.REACT_APP_TRACK_TOKEN}`
            },
        });
        if(response.ok){
            const data = await response.json();
            return {status : true , ...data}
        }else{
            return {status : false , code : `${response.status} - 1 `}
        }
        //;
    } catch (err) {
        return false;
    }
}